export const manifest = {
  screens: {
    scr_g6phug: { name: "Home", route: "/" },
  },
}
